import React from 'react';
import { Field, reduxForm, reset } from 'redux-form';
import { Form, Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { LoadingIcon } from '../components/Loading';
import Input from '../components/Input';
import { RenderDateTimePickerNew } from '../components/DateTimePicker';
import FilePicker from '../components/FilePicker';
import { renderMultiSelectInput } from '../components/SelectInput';

let TreatmentForm = (props) => {
  const {
    handleSubmit,
    submitting,
    isLoading,
    isNew,
    removeFile,
    submitLabel,
    initialValues,
  } = props;
  return (
    <Form onSubmit={handleSubmit}>
      <Field
        component={RenderDateTimePickerNew}
        name="date"
        label="Date of treatment"
        showTime
        initialDate={initialValues.date ? initialValues.date : ''}
        isNew={isNew}
      />
      <Field
        component={Input}
        name="weight"
        type="text"
        label="Body Weight"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="symptoms"
        type="text"
        label="Symptoms"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="diagnosis"
        type="text"
        label="Diagnosis"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="treatment"
        type="text"
        label="Treatment"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="note"
        type="text"
        label="Notes"
        disabled={submitting || isLoading}
      />
      <Field
        name="vaccination"
        id="employed"
        component={renderMultiSelectInput}
        type="checkbox"
        label="Vaccination"
        closeMenuOnSelect={false}
        list={[
          {
            value: 1,
            label: 'Rabies',
          },
          {
            value: 2,
            label: 'Corona',
          },
          {
            value: 3,
            label: 'KC',
          },
          {
            value: 4,
            label: 'DHAPPiL',
          },
          {
            value: 5,
            label: 'Tricat',
          },
        ]}
      />
      <Field
        component={Input}
        name="deworming"
        type="text"
        label="Deworming"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="amount"
        type="text"
        label="Amount"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="precaution"
        type="text"
        label="Precaution"
        disabled={submitting || isLoading}
      />
      <Field
        component={FilePicker}
        name="reports"
        label="Reports"
        disabled={submitting || isLoading}
      />
      {initialValues.reports && (
      <>
        Existing Reports:
      </>
      )}
      {initialValues.reports && initialValues.reports.map((file) => (
        <div key={file}>
          {file.split('%2F')[1].split('?alt')[0]}
          <FontAwesomeIcon onClick={() => { removeFile(file); }} icon={faTimes} />
        </div>
      ))}
      <Button
        type="submit"
        color="primary"
        disabled={submitting || isLoading}
        className="mt-2"
        block
      >
        {isLoading && (
          <LoadingIcon />
        )}
        {submitLabel}
      </Button>
    </Form>
  );
};

const afterSubmit = (result, dispatch) => dispatch(reset('CREATE_TREATMENT'));

TreatmentForm = reduxForm({
  form: 'CREATE_TREATMENT',
  onSubmitSuccess: afterSubmit,
})(TreatmentForm);

export default injectIntl(TreatmentForm);
